import * as React from 'react'
import Link from './helper/link'

interface Props {
    active: string
    showTracepoints: boolean
}

class TraceNavigation extends React.Component<Props> {
    public render = () => (
        <div className="row">
            <div className="col-xs-8">
                <ul className="nav nav-pills nav-pills-tideways">
                    <li className={this.props.active === 'list' ? 'active' : ''}>
                        <Link route="XhprofProfilerBundle.Profile.list">Traces</Link>
                    </li>
                    {this.props.showTracepoints ? (
                        <li className={this.props.active === 'boost' ? 'active' : ''}>
                            <Link route="XhprofProfilerBundle.Profile.listTracepoints">Tracepoints</Link>
                        </li>
                    ) : null}
                    <li className={this.props.active === 'history' ? 'active' : ''}>
                        <Link route="XhprofProfilerBundle.Profile.listTracesHistory">Recently Viewed by You</Link>
                    </li>
                </ul>
            </div>
            <div className="col-xs-4">
                <div className="pull-right">
                    <Link className="btn btn-default" route="XhprofOrganizationBundle.Application.trigger">
                        Trigger Trace
                    </Link>
                </div>
            </div>
        </div>
    )
}
export default TraceNavigation
